import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, Guard } from '@digibricks/domains';
export var UPDATE_ANSWER_USE_CASE = 'UPDATE_ANSWER_USE_CASE';
export var UpdateAnswerUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateAnswerUseCase, _UseCase);

  var _super = _createSuper(UpdateAnswerUseCase);

  function UpdateAnswerUseCase(submissionRepository) {
    var _this;

    _classCallCheck(this, UpdateAnswerUseCase);

    _this = _super.call(this);
    _this.submissionRepository = submissionRepository;
    return _this;
  }

  _createClass(UpdateAnswerUseCase, [{
    key: "validateBaseInput",
    value: function validateBaseInput(useCaseInput) {
      var assignmentEndTime = useCaseInput.assignmentEndTime,
          input = useCaseInput.input;
      var timestamp = input.timestamp;
      var collection = [{
        argument: timestamp,
        argumentName: 'Submission Current Time'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      if (assignmentEndTime) {
        var isOverTime = timestamp > assignmentEndTime;

        if (isOverTime) {
          return Result.fail('Cannot update submission answer after deadline');
        }
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function buildUseCase(input) {
      throw new Error('Method not implemented.');
    }
  }]);

  return UpdateAnswerUseCase;
}(UseCase);